(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fyre-meet-motive"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const motiveVideo = document.querySelector('.meet-motive-video');
  if (!motiveVideo) return;

  const playButton = motiveVideo.querySelector('.video-play');
  if (!playButton) return;

  const iframe = motiveVideo.querySelector('iframe');
  const videoEl = motiveVideo.querySelector('video');

  playButton.addEventListener('click', function () {
    playButton.style.display = 'none';

    // Shopify-hosted video
    if (videoEl) {
      videoEl.play();
    }

    // External embed (YouTube/Vimeo)
    if (iframe) {
      const src = iframe.getAttribute('src');
      if (src && !src.includes('autoplay=1')) {
        iframe.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyre-vert-videos"] && !Shopify.designMode) return;
  try {
    

// VIDEO PLAYER
const video_players = document.querySelectorAll('.video-container');

video_players.forEach(single_video_players => {
    var play_button = single_video_players.querySelector('.video-play'),
        video_bg = single_video_players.querySelector('.video-bg'),
        video_source = play_button.dataset.videoSrc,
        iframe = single_video_players.querySelector('iframe');

    play_button.addEventListener("click", function () {
        // Reset all videos
        video_players.forEach(player => {
            var playerIframe = player.querySelector('iframe');
            playerIframe.src = '';
            player.querySelector('.video-bg').style.display = "block";
            player.querySelector('.video-play').style.display = "block";
            player.classList.remove('active');

            // Reset iframe CSS to initial state
            //playerIframe.style.transition = "none";
            playerIframe.style.opacity = 0;
           // playerIframe.style.transform = "translateX(-50%) scale(0.75)";
            playerIframe.offsetHeight; // Trigger reflow to apply style immediately
           // playerIframe.style.transition = "opacity 0.75s ease-in-out";
        });

        // Set the source for the clicked video
        iframe.src = video_source;
        video_bg.style.display = "none";
        play_button.style.display = "none";
        single_video_players.classList.add('active');

        // Apply fade-in and scale-in transitions to the iframe
       // iframe.click();
        setTimeout(function() {
            iframe.click();
        }, 1000);
        iframe.style.opacity = 1;
        //iframe.style.transform = "translateX(-50%) scale(1)";
    });
});


  } catch(e) { console.error(e); }
})();
})();
